import React, {useEffect, useState} from "react";
import {useEventContext} from "../../../../context";
import {eventStatisticQuizzesGet} from "../../../../../api/cp";
import Loading from "../../../Loading";
import QuizAnswer from "./QuizAnswer";
import Quizzes from "./Quizzes";

export default () => {
    const {event} = useEventContext();
    const [quizzes, setQuizzes] = useState(null);
    const [answer, setAnswer] = useState(null);

    useEffect(fetchQuizzes, []);

    async function fetchQuizzes() {
        try {
            const response = await eventStatisticQuizzesGet(event.eventPassword);
            setQuizzes(response || []);
        } catch (error) {
            console.error(error);
        }
    }

    if (null === quizzes) {
        return <Loading>Загрузка данных квизов</Loading>
    }

    if (answer) {
        return (
            <QuizAnswer
                event={event}
                answer={answer}
                onClose={() => setAnswer(null)}
            />
        );
    }

    return (
        <Quizzes
            event={event}
            quizzes={quizzes}
            onAnswerClick={setAnswer}
        />
    );
}
